import { Outlet } from "react-router-dom";
import { SectionSubnav } from "@/components/core/SectionSubnav";

export default function PerpsLayout() {
  return (
    <div className="pb-8">
      <SectionSubnav
        title="Perps"
        items={[
          { label: "Performance", to: "/app/perps/performance", end: true },
          { label: "Insights", to: "/app/perps/insights" },
          { label: "Positions & Risk", to: "/app/perps/positions-risk" },
          { label: "Funding", to: "/app/perps/funding" },
          { label: "Trades", to: "/app/perps/trades" },
        ]}
      />
      <Outlet />
    </div>
  );
}
